<fieldset
  [class]="radioGroupClass"
  role="radiogroup"
  [ngClass]="{ 'is-error': showError }"
  [attr.aria-required]="required"
  attr.aria-describedBy="{{ invalid ? 'radio-g_' + id + '_error' : '' }}"
  [attr.aria-invalid]="showError"
>
  <legend class="c-radio-list__legend" [innerHTML]="legend"></legend>
  <div class="c-radio-list__wrap">
    <div class="c-radio-list__list">
      <ng-content></ng-content>
    </div>
  </div>
</fieldset>
<ng-container *ngIf="showError">
  <asw-validation-error id="{{ 'radio-g_' + id + '_error' }}" [errorMessage]="errors[0]"></asw-validation-error>
</ng-container>
